var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoRoutal = function SvgLogoRoutal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c6fce976-f9ef-497a-a17f-e4d301bf7729",
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.36,
    height: 28.35,
    viewBox: "0 0 145.36 28.35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db{fill:#fafafa;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-cce7b810-9742-4067-8f54-27342f7b1185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-181bebb0-544b-4a92-ada8-a7226a019656",
    className: "uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db",
    d: "M24.77,14.26c0-7.53,6.11-13.64,13.64-13.64,7.53,0,13.64,6.11,13.64,13.64h0c0,7.54-6.11,13.65-13.64,13.65-7.53,0-13.64-6.11-13.64-13.64h0ZM45.66,14.26c.12-3.99-3.02-7.33-7.01-7.45-3.99-.12-7.33,3.02-7.45,7.01,0,.15,0,.29,0,.44-.12,3.97,2.99,7.29,6.96,7.41.08,0,.16,0,.24,0,4.02,0,7.27-3.26,7.27-7.27,0-.05,0-.09,0-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-30273c20-c7c1-4929-b9a4-87658e7e2499",
    className: "uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db",
    d: "M55.37,17.1V.93h6.47v16.18c0,2.96,1.68,4.64,4.27,4.64s4.34-1.68,4.34-4.64V.93h6.47v16.18c0,6.9-4.2,10.85-10.78,10.85s-10.78-3.94-10.78-10.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-ed8333bc-4ccb-4b1f-aadb-b6fbcc032d6e",
    className: "uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db",
    d: "M86.93,6.81h-7.23V.93h20.6v5.88h-7.16v20.78h-6.21V6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-ef59fbf4-e9bf-46f7-9e70-4f42a65b5727",
    className: "uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db",
    d: "M108.4.93h6.13l9.86,26.66h-6.47l-1.39-3.98h-10.19l-1.39,3.98h-6.43L108.4.93h0ZM108.33,18.06h6.28l-3.14-8.95-3.14,8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-c352ab41-a2d6-4786-b97c-33f104454838",
    className: "uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db",
    d: "M126.63.93h6.39v20.56h11.62v6.1h-18.01V.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-fba05520-a84a-41f6-81c6-5b18b1e6dded",
    className: "uuid-d2ee5790-c47f-4cd3-a4c7-9d7d0a7355db",
    d: "M18.04,17.58c2.74-1.65,4.39-4.65,4.31-7.85,0-5.05-3.58-9.17-10.01-9.17H.88v4.66c0,2.59,2.1,4.69,4.69,4.69-2.59,0-4.69,2.1-4.69,4.69v12.62h6.36v-8h5l3.76,8h7.01l-4.97-9.64ZM16.3,9.94c-2.49.54-4.44,2.49-4.99,4.98v.02-.05c-.56-2.48-2.5-4.41-4.97-4.97h-.02,0c2.48-.55,4.42-2.49,4.98-4.97v.02c.55,2.48,2.48,4.41,4.96,4.97h.04s0,0,0,0Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoRoutal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo-routal.eb4b2c8371f4000e9bf37318487f5b7e.svg";